import { Navigate, useParams } from 'react-router-dom';
import { campResidentsHref } from './worksiteDialogHref.js';

/**
 * THE RETIRED CAMP PAGE'S ADDRESS, KEPT ALIVE.
 *
 * `/worksites/:id/camp-occupancy` was a camp-only page until a camp moved onto
 * the worksite page (owner, 2026-11-03). Bookmarks and old links land on that
 * page's Residents tab — the same roster. `replace`, so Back does not bounce.
 *
 * A REDIRECT, NOT A PAGE, and the route guards know it by this name
 * (`navigationWiring.test.ts`, `routeGates.test.tsx`): the destination carries
 * the gate, and no in-app link may point here.
 */
export function CampOccupancyRedirect(): JSX.Element {
  const { id = '' } = useParams<{ id: string }>();
  return <Navigate to={campResidentsHref(id)} replace />;
}
